import get from 'lodash/get'

export default accountStatusTimeline

/** @ngInject */
function accountStatusTimeline(DeviceChecker, ContractStatusLabel) {
    return ({
        restrict: 'E',
        scope: {
            userContract: '<',
            displayTitle: '<',
        },
        template: require('./accountStatusTimeline.jade')(),
        link($scope) {
            const TIMELINE_STEP = {
                DISABLED: 0,
                PRISE_DE_COMMANDE: 1,
                VALIDATION_DE_LA_COMMANDE: 2,
                ACTIVATION_DE_LA_COMMANDE: 3,
                CONTRAT_ACTIF: 4,
            }

            $scope.isTimelineVisible = false
            $scope.statusColor2 = false
            $scope.status2 = false
            $scope.statusColor3 = false
            $scope.status3 = false
            $scope.status4 = false

            $scope.isTab = DeviceChecker.isTab

            const activate = function () {
                const contractStatus = get(ContractStatusLabel, [$scope.userContract.status], ContractStatusLabel.unknown)
                $scope.currentTimelineStep = contractStatus.timelineStep
                $scope.stepName1 = contractStatus.isWaitingAction ? 'EN ATTENTE' : 'EN PREPARATION'

                switch ($scope.currentTimelineStep) {
                    case TIMELINE_STEP.DISABLED:
                        $scope.isTimelineVisible = false
                        $scope.status2 = false
                        $scope.statusColor2 = false
                        $scope.status3 = false
                        $scope.statusColor3 = false
                        $scope.status4 = false
                        break
                    case TIMELINE_STEP.PRISE_DE_COMMANDE:
                        $scope.isTimelineVisible = true
                        $scope.status2 = false
                        $scope.statusColor2 = false
                        $scope.status3 = false
                        $scope.statusColor3 = false
                        $scope.status4 = false
                        break
                    case TIMELINE_STEP.VALIDATION_DE_LA_COMMANDE:
                        $scope.isTimelineVisible = true
                        $scope.status2 = true
                        $scope.statusColor2 = true
                        $scope.status3 = false
                        $scope.statusColor3 = false
                        $scope.status4 = false
                        break
                    case TIMELINE_STEP.ACTIVATION_DE_LA_COMMANDE:
                        $scope.isTimelineVisible = true
                        $scope.status2 = true
                        $scope.statusColor2 = true
                        $scope.status3 = true
                        $scope.statusColor3 = true
                        $scope.status4 = false
                        break
                    case TIMELINE_STEP.CONTRAT_ACTIF:
                        $scope.isTimelineVisible = true
                        $scope.status2 = true
                        $scope.statusColor2 = true
                        $scope.status3 = true
                        $scope.statusColor3 = true
                        $scope.status4 = true
                        break
                    default:
                        $scope.isTimelineVisible = false
                        $scope.status2 = false
                        $scope.statusColor2 = false
                        $scope.status3 = false
                        $scope.statusColor3 = false
                        $scope.status4 = false
                        break
                }
            }

            activate()
            $scope.$watch('userContract', activate)
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/account/component/accountStatusTimeline.js